<template>
  <div class="name-info">
    <div class="r-text-intro">פרטים אישיים | כמו שמופיעים בת.ז.</div>
    <div class="r-text-headline-paragraph">
      צריך לוודא שהשם כאן הוא בדיוק כמו בת.ז.
    </div>
    <div class="r-form-row">
        <default-text-input
          :value="firstName"
          label="שם פרטי"
          autofocus
          validations="required|nameCharacters"
          @observe="observe"
          @input="setFirstName" />
      </div>

      <div class="r-form-row">
        <default-text-input
          :value="lastName"
          label="שם משפחה"
          validations="required|nameCharacters"
          @observe="observe"
          @input="setLastName"/>
      </div>

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'NameInfo',
  components: { DefaultButton, DefaultTextInput },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['firstName', 'lastName']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setFirstName', 'setLastName']),
  },
};
</script>
